import { render, staticRenderFns } from "./dialog-manageheaderinbox.vue?vue&type=template&id=2cfe8675&"
import script from "./dialog-manageheaderinbox.vue?vue&type=script&lang=js&"
export * from "./dialog-manageheaderinbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports